<template>
    <div v-if="isLoaded">
        <a v-for="banner in banners"
           :key="banner.id"
           :href="banner.getUrl(zone)"
           class="cam-banner"
           :style="{backgroundImage: 'url(' + banner.image + ')'}"
           target="_blank"
           @click="go($event, banner)"
           v-analytics='["click", camsApi.name, zone]'
           data-one-click-exclude="cams"
        >
            <div class="cam-live-indicator">
                {{ $t('global_camsLiveNow') }}
            </div>

            <div class="cam-banner-headline">
                <div>{{ banner.performerName }}</div>
                <div>{{ banner.description }}</div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'CamBannerArea',

        data() {
            return {
                isLoaded: false,
                banners: [],
            };
        },

        props: {
            zone: { type: String, default: '' },
            gender: { type: String, default: null },
            count: { type: Number, default: 1 },
        },

        // This API is resolved dynamically on page load
        inject: ['camsApi'],

        async mounted() {
            if (this.camsApi.isActive) {
                await this.load();
            }
        },

        methods: {
            async load() {
                this.isLoaded = false;

                try {
                    this.banners = await this.camsApi.getBanners(this.count, this.gender);
                } finally {
                    this.isLoaded = true;
                    this.$emit('loaded');
                }
            },

            go(event, banner) {
                if (!this.camsApi.needsConfirmation) {
                    return;
                }

                event.preventDefault();
                this.$root.showPopup('camsConfirmation', {zone: this.zone, performer: banner.performerCode});
            },
        },
    }
</script>

<style>
    .-hp-cam-banner-area {
        padding-bottom: 20px;
    }

    .cam-horizontal-banners,
    .cam-vertical-banners,
    .cam-video-banners {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }

    .cam-banner {
        position: relative;
        padding-top: 100%;
        background-size: cover;
        background-position: center;
    }

    .cam-banner:after,
    .cam-banner:before {
        content: '';
        position: absolute;
        left: -10px;
        top: -10px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }

    .cam-banner:after {
        z-index: 3;
        background: #000;
    }

    .cam-banner:before {
        z-index: 4;
        background: rgb(24,168,3);
        transform: scale(0.15);
        animation: animLiveCamsDot .8s linear 0s infinite;
    }

    @keyframes animLiveCamsDot {
        from {transform: scale(0.15);}
        to {transform: scale(0.60);}
    }

    .cam-banner-headline {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 5px;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;

        display: flex;
        justify-content: space-between;
        text-transform: capitalize;
    }

    .cam-live-indicator {
        position: absolute;
        top: 0;
        left: 0;
        background: rgb(24,168,3);
        background: linear-gradient(90deg, rgba(24,168,3,1) 0%, rgba(26,145,7,1) 100%);
        border-radius: 0 0 3px 0;
        color: #fff;
        font-weight: bold;
        font-size: 12px;
        padding: 5px 10px;
        z-index: 3;
    }

    @media (min-width: 768px) {
        .-hp-cam-banner-area {
            padding-bottom: 40px;
        }

        .cam-horizontal-banners {
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        }
        .cam-vertical-banners {
            grid-template-columns: 1fr;
        }
        .cam-video-banners {
            gap: 20px;
        }
        .cam-video-banners .cam-banner {
            padding-top: 56.25%;
        }
    }

    @media (min-width: 1000px) {
        .cam-horizontal-banners,
        .cam-vertical-banners {
            gap: 20px;
        }

        .cam-video-banners {
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        }

        .cam-banner {
            min-width: 0;
        }

        .cam-banner-headline {
            padding: 10px;
        }
    }
</style>
